import MDBox from "components/MDBox";
import { useEffect, useState } from "react";
import "./StartRating.css";

import UsersApi from "Classes/API/UsersApi";
import CreateFeedback from "Classes/Models/Requests/Appointments/CreateFeedback";
import Loader from "layouts/loader/loader";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import translations from "./translations.js"; // Adjust the path

// StarRating component
const StarRating = ({ value, onChange }) => {
  const [hoveredValue, setHoveredValue] = useState(null);

  const handleMouseOver = (starValue) => {
    setHoveredValue(starValue);
  };

  const handleMouseLeave = () => {
    setHoveredValue(null);
  };

  const handleClick = (starValue) => {
    onChange(starValue);
  };

  return (
    <div className="star-rating">
      {[1, 2, 3, 4, 5].map((star) => (
        <span
          key={star}
          className={`star ${star <= (hoveredValue || value) ? "filled" : ""}`}
          onMouseOver={() => handleMouseOver(star)}
          onMouseLeave={handleMouseLeave}
          onClick={() => handleClick(star)}
        >
          &#9733; {/* Unicode character for a star */}
        </span>
      ))}
    </div>
  );
};

// FeedbackForm component
const FeedbackForm = () => {
  const [language, setLanguage] = useState("en"); // Default language is English
  const changeLanguage = () => {
    setLanguage(language === "en" ? "ar" : "en");
  };

  const translate = (key) => translations[language][key] || key;

  // State to manage form values
  const [rating, setRating] = useState(1);
  const [description, setDescription] = useState("");
  const [patientName, setPatientName] = useState("");
  const [doctorName, setDoctorName] = useState("");
  const [Loading, setLoading] = useState(false);
  const hideElementById = () => {
    const element = document.getElementById("TheSidenav");

    if (element) {
      element.style.display = "none";
    }
  };

  useEffect(() => {
    hideElementById();
  }, []);

  const handleRatingChange = (newRating) => {
    setRating(newRating);
  };

  const handleDescriptionChange = (event) => {
    setDescription(event.target.value);
  };
  const { tenantId } = useParams();
  const baseURL = window.location.origin;
  const redirectLink = `${baseURL}/Appointments/FeedbackForm/${tenantId}`;
  const handleSubmit = (event) => {
    event.preventDefault();
    setLoading(true);

    console.log("Rating:", rating);
    console.log("Description:", description);

    console.log("s");
    let Feedback = new CreateFeedback();

    Feedback.Rate = rating;
    Feedback.description = description;
    Feedback.patientName = patientName;
    Feedback.doctorName = doctorName;
    Feedback.AccountingSessionID = 0;

    UsersApi.CreateFeedback({ tenant: tenantId, ...Feedback }).then((result) => {
      if (result.status == "Success") {
        setLoading(false);
        Swal.fire("Success", "Feedback created successfully", "success");
      }
    });
  };

  return (
    <div>
      <MDBox mt={6} mb={3}>
        {Loading ? (
          <Loader />
        ) : (
          <div dir={language === "ar" ? "rtl" : "ltr"}>
            <div>
              <div className="row">
                <div className="container">
                  <div className="card">
                    <div className="card-header text-center">
                      {translate("feedbackForm")} |{" "}
                      <button className="btn btn-info btn-sm" onClick={() => changeLanguage()}>
                        {language === "en" ? " عربى" : "english"}
                      </button>
                    </div>
                    <div className="card-body">
                      <div className="card-body">
                        <div className="row">
                          <div className="container">
                            <div className="row">
                              <div className="col-md-12 col-lg-12 col-xl-12">
                                <form onSubmit={handleSubmit}>
                                  <div>
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder={translate("patientName")}
                                      id="patientName"
                                      value={patientName}
                                      onChange={(e) => setPatientName(e.target.value)}
                                    />
                                  </div>
                                  <div className="mt-2">
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder={translate("doctorOrEmployeeName")}
                                      id="doctorName"
                                      value={doctorName}
                                      onChange={(e) => setDoctorName(e.target.value)}
                                    />
                                  </div>
                                  <div className="my-3">
                                    <label htmlFor="rating">{translate("rateExperience")}</label>
                                    <br></br>
                                    <StarRating value={rating} onChange={handleRatingChange} />
                                  </div>
                                  <div>
                                    <textarea
                                      type="text"
                                      className="form-control"
                                      placeholder={translate("description")}
                                      id="description"
                                      value={description}
                                      onChange={handleDescriptionChange}
                                    />
                                  </div>
                                  <button className="btn btn-primary mt-4" type="submit">
                                    {translate("submit")}
                                  </button>
                                </form>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </MDBox>
    </div>
  );
};

export default FeedbackForm;
